'use client';

import Footer from '@components/footer/Footer';
import Modals from '@components/Modals';
import { CartDrawer } from '@components/Modals/components/CartDrawer';
// Client-side wrapper components for components that use hooks
export { Footer, Modals, CartDrawer };